
import SummaryAsset from "@/components/summary-panel/SummaryAsset.vue";
import SummaryFinancement from "@/components/summary-panel/SummaryFinancing.vue";
import SummaryTiers from "@/components/summary-panel/SummaryTiers.vue";
import router from "@/router";
import store from "@/store";
import { MessageToSend, MessageToSendEnum, OfferStatus } from "@/types";
import { getOfferFromState } from "@/utils";
import { Options, Vue } from "vue-class-component";
import SummaryMessage from "@/components/summary-panel/SummaryMessage.vue";
import SummaryHistory from "@/components/summary-panel/SummaryHistory.vue";
import { saveDashboardDemandFilter } from "@/utils/homeDashboardNavigation";
import { deleteOffer as deleteOfferRequest } from "@/store/services/offerService";
import { sendMessage } from "@/store/services/task/workflow";

@Options({
  components: {SummaryHistory, SummaryMessage, SummaryFinancement, SummaryAsset, SummaryTiers },
})
export default class SummaryPanel extends Vue {
  summarySelected = "TIERS";
  // Offre lue dans le store a chaque acces (et non copiee au montage) :
  // le panneau suit la demande / Task reellement affichee.
  get offer() {
    return getOfferFromState(store.state, this.$route?.name);
  }
  showDeleteOfferDialog = false;
  showDeleteOfferSureDialog = false;
  get historiesStep() {
    return store.state.middleOfficeModule.historiesStep || [];
  }
  get isTaskModuleOrder() {
    return store.getters['taskModule/isTaskModuleOrder']
  }

  get isAdmin() {
    const authorities = store.state.authModule?.user?.authorities || [];
    const hasAdminAuthority = authorities.some(
      (item: any) => item?.authority === "ROLE_ADMIN" || item?.resourceUid === "ROLE_ADMIN"
    );
    if (hasAdminAuthority) {
      return true;
    }

    const groups = store.state.authModule?.groups || [];
    return groups.some((item: any) => {
      const resourceUid = item?.group?.resourceUid ?? item?.resourceUid;
      return resourceUid === "GRP_ADMIN" || resourceUid === "ROLE_ADMIN";
    });
  }

  setSummary(summaryBlock: string) {
    this.summarySelected = summaryBlock;
  }

  created() {
    if (!this.isTaskModuleOrder) {
      const offer = this.offer;
      if (offer) {
        if (this.isTaskAnalysis) {
          store.dispatch("summaryPanelModule/setOfferFromTask", { offer });
        } else {
          store.dispatch("summaryPanelModule/setOffer", { offer });
        }
      }
      if (this.summaryPanel) {
        store.dispatch("summaryPanelModule/loadRatings");
      }
    }
  }
  get currentRoute() {
    return this.$route?.name;
  }

  get isTaskAnalysis() {
    return store.getters["taskModule/isTaskAnalysis"];
  }

  get summaryPanel() {
    return store.state.middleOfficeModule.summaryPanel;
  }

  get asset() {
    return store.state.summaryPanelModule.offer?.proposals?.[0]?.proposalItems?.[0];
  }

  get parties() {
    if (this.currentRoute === "mo-demand-detail") {
      return store.state.middleOfficeModule.offer?.associatedParties;
    }
    return store.state.taskModule.offer?.associatedParties || store.state.middleOfficeModule.offer?.associatedParties;
  }

  get tabSelected() {
    return this.summarySelected ? this.summarySelected : "TIERS";
  }

  openDeleteOfferDialog() {
    this.showDeleteOfferDialog = true;
  }

  confirmDeleteOffer() {
    this.showDeleteOfferDialog = false;
    this.showDeleteOfferSureDialog = true;
  }

  async deleteOffer() {
    this.showDeleteOfferSureDialog = false;
    if (!this.isAdmin) {
      return;
    }

    const offer = store.state.middleOfficeModule.offer;
    const offerId = offer?.resourceUid;
    if (!offerId) {
      return;
    }
    const messageToSend : MessageToSend = {
    "messageName": MessageToSendEnum.CANCEL_Offer,
    "businessKey": offerId
}

    try {
      await deleteOfferRequest(offerId);
      await sendMessage(messageToSend);
      console.log("offre supprimee");
      if (offer?.reference) {
        saveDashboardDemandFilter({ reference: offer.reference });
      }
      router.push("/demand/list");
    } catch {
      return;
    }
  }

  isMo() {
    return this.currentRoute !== 'TaskDetail';

  }
  openSummaryPanel() {
    const wasOpen = store.state.middleOfficeModule.summaryPanel;
    store.state.middleOfficeModule.summaryPanel = !wasOpen;
    if (wasOpen) {
      this.summarySelected = "TIERS";
    } else {
      const offer = this.offer;
      if (offer) {
        store.dispatch("summaryPanelModule/setOffer", { offer });
      }
      store.dispatch("summaryPanelModule/loadRatings");
    }
  }

  openNewTab() {
    const offer = this.offer;
    if(offer?.status?.resourceUid){
      store.dispatch("demandModule/getProposalStatus", {
      statusId: offer.status.resourceUid,
      callback: (result: any) => {
        const routePath = [
          OfferStatus.DECISION,
          OfferStatus.CONTRACT,
          OfferStatus.CANCELLED,
        ].includes(result.internalCode)
          ? "/mo/demand/detail/"
          : "/demand/edit/";
        const routeData = router.resolve(`${routePath}${offer.resourceUid}`);
        window.open(routeData.href, "_blank");
      },
    });
  
    }
    }
}
